import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { MdPhoneIphone } from "react-icons/md";
import "./ComingSoonBanner.css";

function ComingSoonBanner() {
  const { t } = useTranslation();
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const id = window.setTimeout(() => setVisible(true), 700);
    return () => window.clearTimeout(id);
  }, []);

  if (!visible) return null;

  return (
    <aside className="coming-soon-banner" role="status" aria-live="polite">
      <MdPhoneIphone className="coming-soon-banner-icon" size={18} aria-hidden />
      <span className="coming-soon-banner-title">{t("comingSoon.title")}</span>
      <button
        type="button"
        className="coming-soon-banner-close"
        onClick={() => setVisible(false)}
        aria-label={t("comingSoon.dismiss")}
      >
        <svg width="12" height="12" viewBox="0 0 24 24" fill="none" aria-hidden>
          <path
            d="M18 6L6 18M6 6l12 12"
            stroke="currentColor"
            strokeWidth="2"
            strokeLinecap="round"
          />
        </svg>
      </button>
    </aside>
  );
}

export default ComingSoonBanner;
